import { formatCurrency } from '@monetize/utils/core';
import { MdInfo } from 'react-icons/md';
import { getDaysOutstanding } from '../utils/invoices';
import { MBox, MFlex, MIcon, MText, MTooltip } from './Monetize';

interface PastDueIndicatorIconProps {
  pastDueInvoiceCount?: number | null;
  pastDueAmount?: number | null;
  minimumInvoiceDueDate?: string | null;
  currency?: string | null;
}

export const PastDueIndicatorIcon = ({
  pastDueInvoiceCount,
  pastDueAmount,
  minimumInvoiceDueDate,
  currency,
}: PastDueIndicatorIconProps) => {
  const count = pastDueInvoiceCount ?? 0;
  const amount = pastDueAmount ?? 0;
  const daysOutstanding = getDaysOutstanding(minimumInvoiceDueDate);

  if (count <= 0 && amount <= 0) {
    return null;
  }

  const countLabel =
    count > 0
      ? `${count} past-due ${count === 1 ? 'invoice' : 'invoices'}`
      : 'One or more invoices are past-due';

  const label = (
    <MFlex direction="column" gap={0.5}>
      <MText color="inherit">{countLabel}</MText>
      {amount > 0 && (
        <MText color="inherit">
          {`Past Due: ${formatCurrency(amount, {
            currency: currency ?? 'USD',
            maximumFractionDigits: 2,
          })}`}
        </MText>
      )}
      {daysOutstanding > 0 && (
        <MText color="inherit">{`Days Outstanding: ${daysOutstanding}`}</MText>
      )}
    </MFlex>
  );

  return (
    <MTooltip label={label} placement="bottom-start">
      <MBox display="inline" tabIndex={0} role="img" aria-label={countLabel}>
        <MIcon
          as={MdInfo}
          w={4}
          h={4}
          color="tRed.base"
          transform="rotate(180deg)"
        />
      </MBox>
    </MTooltip>
  );
};
